query SubscriptionsList($page: Int, $rowsPerPage: Int, $filter: JSON) {
  subscriptions(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      platformId
      organizationId
      status
      startAt
      currentPeriodEnd
      renewSubscription
      billingCyclesComplete
      renewAttempts
      nextRenewAttemptAt
      renewErrorReason
      organization {
        title
      }
    }
  }
}
